<template>
  <div>
    <publicHeader @child-event="myInfoEvent"></publicHeader>
    <studyHeader
      :subjectIndex="subjectIndex"
      :studyNav="studyNav"
      :myInfo="myInfo"
      :public="public"
    ></studyHeader>
    <div class="practice bg_gray practice_second">
      <div class="my_position flex">
        <div class="my_position_l cl_gray">
          <img src="../../../static/icon_position.png" class="mar5" />
          <p>
            当前位置：<router-link to="/" class="cl_gray">首页</router-link> >
            <router-link to="/study" class="cl_gray">趣学习</router-link> >
            <router-link to="/practice" class="cl_gray">练习</router-link> >
            {{ chapter_name }}
          </p>
        </div>
        <div class="my_position_r cl_violet" @click="$router.go(-1)">
          <span class="mar5">返回上级</span
          ><img src="../../../static/return_violet.png" />
        </div>
      </div>
      <div class="w1200 flex">
        <div class="practice_l bg_white radius8">
          <div class="practice_list_cont f20px">
            <div
              class="practice_list"
              v-for="(item, index) in list"
              :key="index"
              :class="[{ on: item.name == '' }, { open: item.show == 1 }]"
            >
              <div
                class="practice_list_title flex"
                v-if="item.name != ''"
                @click="listOpen(index)"
              >
                <p>
                  <img
                    src="../../../static/practice_list.png"
                    class="mar5"
                  /><span>{{ item.name }}</span>
                </p>
                <img src="../../../static/select_violet.png" />
              </div>
              <div class="practice_list_hide f18px cl_dark mat10">
                <div
                  class="practice_list_second flex"
                  v-for="(item, secondIndex) in item.subordinate"
                  :key="secondIndex"
                  @click="practice(index, secondIndex)"
                >
                  <span>{{ item.knowledge_name }}</span>
                  <div class="flex">
                    <i class="cl_gray f14px mar5">开始练习</i>
                    <img src="../../../static/more_gray.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="practice_r bg_white radius8">
          <div class="practice_title f20px cl_dark">我的题库</div>
          <img
            src="../../../static/wrong.png"
            class="block practice_r_img mat20 mab20"
          />
          <div class="practice_r_cont f16px">
            <router-link to="/wrong" class="practice_r_list flex">
              <div class="practice_r_list_l">
                <img src="../../../static/wrong_topic.png" class="mar5" />
                <span>错题本</span>
              </div>
              <i class="cl_yel">{{ myInfo.user_question_err_num }}</i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <vfooter @child-event="publicEvent"></vfooter>
    <!-- 难度弹窗 -->
    <div class="bg" @click="degreeClose" v-if="degreeShow == true"></div>
    <div class="degree bg_white radius8" :class="{ on: degreeShow }">
      <div class="degree_header">
        <img src="../../../static/close_violet.png" @click="degreeClose" />
      </div>
      <div class="degree_title tc f20px">请选择题目的难度</div>
      <div class="degree_cont tc f16px cl_gray mat30">
        <div class="degree_list" @click="degreeList(1)">非常简单</div>
        <div class="degree_list" @click="degreeList(2)">简单</div>
        <div class="degree_list" @click="degreeList(3)">一般</div>
        <div class="degree_list" @click="degreeList(4)">难</div>
        <div class="degree_list" @click="degreeList(5)">非常难</div>
      </div>
    </div>
  </div>
</template>

<script>
import publicHeader from "../../components/header.vue";
import studyHeader from "../../components/study_header.vue";
import vfooter from "../../components/footer.vue";
export default {
  name: "practice_list",
  components: {
    publicHeader,
    studyHeader,
    vfooter,
  },
  props: {},
  data() {
    return {
      subjectIndex: false, //学科分类显示
      studyNav: 1, //导航
      myInfo: {},
      public: {},
      chapter_name: "", //章节名称
      list: {
        list: [],
      }, //知识点列表
      degreeShow: false, //弹窗显示
      points: {}, //选中知识点
      limit: 5, //题目个数
      subject_id: "",
      grade_id: "",
      edition_id: "",
    };
  },
  mounted() {},
  watch: {},
  created() {
    if (this.$route.query.chapter_name) {
      this.chapter_name = this.$route.query.chapter_name;
      this.subject_id = this.$route.query.subject_id;
      this.grade_id = this.$route.query.grade_id;
      this.edition_id = this.$route.query.edition_id;
      this.getList();
    }
  },
  methods: {
    myInfoEvent(data) {
      this.myInfo = data;
    },
    publicEvent(data) {
      this.public = data;
    },
    //获取列表
    getList() {
      this.$get("/api/exercise/get_lessons_data", {
        name: this.chapter_name,
        subject_id: this.subject_id,
        grade_id: this.grade_id,
        edition_id: this.edition_id,
      }).then((res) => {
        this.list = res.data;
      });
    },
    listOpen(e) {
      if (this.list[e].show == 0) {
        this.list[e].show = 1;
      } else {
        this.list[e].show = 0;
      }
    },
    //难度弹窗
    practice(index, second) {
      this.degreeShow = true;
      this.points = this.list[index].subordinate[second];
      console.log(this.points);
    },
    //关闭
    degreeClose() {
      this.degreeShow = false;
    },
    //难度选择
    degreeList(e) {
      this.degreeShow = false;
      this.$router.push({
        path: "/practice_test",
        query: {
          knowledge_id: this.points.knowledge_id,
          diff: e,
          limit: this.limit,
        },
      });
    },
  },
};
</script>

<style>
</style>
